module.exports = __webpack_public_path__ + "static/media/email-logo-blue.d0f29361.png";